/* ════════════════════════════════════════════════════════════════════
 *  EMPREGARE — SITE INSTITUCIONAL B2B  ·  Diagnóstico (quiz gamificado)
 *  Compilado pelo webpack → js/build/empresa-v2-diagnostico.min.js
 *  Carregado SOMENTE na página /business/diagnostico.
 *
 *  Fluxo: intro → q1..q7 → lead → result
 *    q1 porte · q2 ATS · q3 admissão · q4 horas/processo · q5 processos/mês
 *    q6 salário médio das vagas · q7 principal dor
 *
 *  Responsabilidades:
 *    · Navegação Typeform-style (uma tela por vez) + barra de progresso
 *    · Captura de lead CLIENT-SIDE (validação no navegador; SEM envio ao
 *      backend nesta etapa — a integração comercial vem depois)
 *    · CÁLCULO do diagnóstico (fiel à fórmula oficial da ferramenta atual)
 *    · ÍNDICE DE MATURIDADE (0–100) — modelo próprio documentado abaixo
 *    · RELATÓRIO de conversão: número-âncora anual, comparativo Hoje ×
 *      Empregare, risco de contratação errada (benchmark de mercado) e
 *      plano de ação personalizado por respostas/dor.
 *
 *  ⚠️ Todo o cálculo roda no client (cultura pt-BR / regra de decimais em
 *     SVG/Razor). As constantes vêm de data-attributes na view.
 * ════════════════════════════════════════════════════════════════════ */

(function () {
    'use strict';

    function ready(fn) {
        if (document.readyState !== 'loading') { fn(); }
        else { document.addEventListener('DOMContentLoaded', fn); }
    }

    ready(function () {
        var quiz = document.querySelector('[data-dx-quiz]');
        if (!quiz) return;

        var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // ── Constantes do cálculo (DADOS OFICIAIS via data-attributes) ──
        var CUSTO_HORA = parseFloat(quiz.getAttribute('data-custo-hora')) || 18.75; // R$ 3.000 / 160h (hora de Analista de RH)
        var REDUCAO    = parseFloat(quiz.getAttribute('data-reducao'))    || 0.90;  // 90% de redução de tempo por processo (fato oficial do site — NÃO usar 81%)
        var BAD_HIRE   = parseFloat(quiz.getAttribute('data-bad-hire'))   || 0.30;  // contratação errada ≈ 30% do salário anual (piso de mercado)
        var resultActionUrl = quiz.getAttribute('data-result-action') || '#';
        var enviarUrl = quiz.getAttribute('data-dx-enviar') || '';            // endpoint POST (persistir lead + e-mail comercial)

        // ── Sequência de telas ─────────────────────────────────────────
        var ORDER = ['intro', 'q1', 'q2', 'q3', 'q4', 'q5', 'q6', 'q7', 'lead', 'result'];
        // telas que contam para a barra de progresso (perguntas + lead)
        var PROGRESS_STEPS = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6', 'q7', 'lead'];

        var steps = {};
        ORDER.forEach(function (id) {
            steps[id] = quiz.querySelector('[data-dx-step="' + id + '"]');
        });

        // ── Estado das respostas ───────────────────────────────────────
        var answers = {
            porte: null,         // nº de colaboradores (valor representativo)
            usaAts: null,        // 0/1
            admissao: null,      // 'papel' | 'parcial' | 'digital'
            horasProcesso: null, // horas por processo
            processosMes: null,  // processos por mês
            salario: null,       // salário médio das vagas (valor representativo da faixa)
            dor: null            // principal dor (string)
        };

        var currentId = 'intro';

        // ── Barra de progresso (no layout) ──────────────────────────────
        var progressEl = document.querySelector('[data-dx-progress]');
        var progressFill = document.querySelector('[data-dx-progress-fill]');

        function setProgress(id) {
            var idx = PROGRESS_STEPS.indexOf(id);
            var pct;
            if (id === 'intro') pct = 0;
            else if (id === 'result') pct = 100;
            else pct = Math.round(((idx + 1) / PROGRESS_STEPS.length) * 100);
            if (progressFill) progressFill.style.width = pct + '%';
            if (progressEl) progressEl.setAttribute('aria-valuenow', String(pct));
        }

        // ── Troca de tela ───────────────────────────────────────────────
        function show(id) {
            if (!steps[id]) return;
            Object.keys(steps).forEach(function (key) {
                var el = steps[key];
                if (!el) return;
                var on = key === id;
                el.classList.toggle('is-active', on);
                el.hidden = !on;
            });
            currentId = id;
            setProgress(id);

            // foca o título da tela (acessibilidade + leva o leitor de tela ao novo conteúdo)
            var heading = steps[id].querySelector('h1, h2, [tabindex="-1"]');
            if (heading) {
                if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
                try { heading.focus({ preventScroll: false }); } catch (e) { heading.focus(); }
            }
            window.scrollTo({ top: 0, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
        }

        function go(direction) {
            var idx = ORDER.indexOf(currentId);
            var nextIdx = idx + direction;
            if (nextIdx < 0 || nextIdx >= ORDER.length) return;
            show(ORDER[nextIdx]);
        }

        // ── Validação por tela (antes de avançar) ───────────────────────
        function isStepAnswered(id) {
            var step = steps[id];
            if (!step) return true;
            var kind = step.getAttribute('data-dx-kind');
            var key = step.getAttribute('data-dx-key');
            if (kind === 'choice') return answers[key] !== null;
            if (kind === 'number') return answers[key] !== null && !isNaN(answers[key]) && answers[key] > 0;
            return true;
        }

        // ── INTRO: botão começar ────────────────────────────────────────
        var startBtn = quiz.querySelector('[data-dx-start]');
        if (startBtn) startBtn.addEventListener('click', function () { show('q1'); });

        // ── Botões "Voltar" (em qualquer tela) ──────────────────────────
        quiz.querySelectorAll('[data-dx-back]').forEach(function (btn) {
            btn.addEventListener('click', function () { go(-1); });
        });

        // ── Botões "Continuar/Próximo" (telas de número) ────────────────
        quiz.querySelectorAll('[data-dx-next]').forEach(function (btn) {
            btn.addEventListener('click', function () {
                if (isStepAnswered(currentId)) go(1);
            });
        });

        // ── Perguntas de ESCOLHA (boolean / faixa / múltipla) ───────────
        // Selecionar avança automaticamente (sensação de fluidez Typeform).
        quiz.querySelectorAll('[data-dx-step][data-dx-kind="choice"]').forEach(function (step) {
            var key = step.getAttribute('data-dx-key');
            var choices = Array.prototype.slice.call(step.querySelectorAll('[data-dx-choice]'));

            function select(btn) {
                choices.forEach(function (c) {
                    var on = c === btn;
                    c.classList.toggle('is-selected', on);
                    c.setAttribute('aria-checked', String(on));
                });
                var raw = btn.getAttribute('data-dx-value');
                // valores numéricos viram número; rótulos (admissão/dor) ficam string
                answers[key] = /^-?\d+$/.test(raw) ? parseInt(raw, 10) : raw;

                // pequena pausa para o feedback visual antes de avançar
                window.setTimeout(function () { go(1); }, prefersReducedMotion ? 0 : 260);
            }

            choices.forEach(function (btn) {
                btn.addEventListener('click', function () { select(btn); });
            });
        });

        // ── Perguntas NUMÉRICAS (stepper + chips rápidos) ───────────────
        quiz.querySelectorAll('[data-dx-step][data-dx-kind="number"]').forEach(function (step) {
            var key = step.getAttribute('data-dx-key');
            var input = step.querySelector('[data-dx-input]');
            var dec = step.querySelector('[data-dx-dec]');
            var inc = step.querySelector('[data-dx-inc]');
            var min = parseFloat(step.getAttribute('data-dx-min')) || 1;
            var max = parseFloat(step.getAttribute('data-dx-max')) || 1000;
            var def = parseFloat(step.getAttribute('data-dx-default')) || min;

            // semente do estado com o valor padrão da view
            answers[key] = def;

            function clamp(v) {
                if (isNaN(v)) v = def;
                return Math.max(min, Math.min(max, Math.round(v)));
            }
            function setValue(v) {
                var c = clamp(v);
                input.value = c;
                answers[key] = c;
            }

            if (input) {
                input.addEventListener('input', function () {
                    var v = parseFloat(input.value);
                    answers[key] = isNaN(v) ? null : v; // valida no avançar; não força clamp enquanto digita
                });
                input.addEventListener('blur', function () { setValue(parseFloat(input.value)); });
                input.addEventListener('keydown', function (e) {
                    if (e.key === 'Enter') { e.preventDefault(); setValue(parseFloat(input.value)); if (isStepAnswered(currentId)) go(1); }
                });
            }
            // Stepper +/- com press-and-hold (auto-repeat).
            // 1 toque = 1 passo; segurar = incrementa continuamente (acelera após o início).
            // O `touch-action: manipulation` no CSS já elimina o double-tap-to-zoom / delay no mobile.
            function bindStep(btn, delta) {
                if (!btn) return;
                var holdTimer = null, repeatTimer = null;

                function step() { setValue((parseFloat(input.value) || def) + delta); }
                function stop() {
                    if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
                    if (repeatTimer) { clearInterval(repeatTimer); repeatTimer = null; }
                }
                function start(e) {
                    // só botão esquerdo do mouse / toque (ignora botão direito)
                    if (e.button && e.button !== 0) return;
                    stop();
                    step(); // 1º passo imediato
                    holdTimer = setTimeout(function () {
                        repeatTimer = setInterval(step, 70); // auto-repeat ao segurar
                    }, 380);
                }

                if (window.PointerEvent) {
                    btn.addEventListener('pointerdown', function (e) {
                        start(e);
                        // mantém os próximos pointer events neste botão mesmo se o dedo deslizar
                        if (btn.setPointerCapture) { try { btn.setPointerCapture(e.pointerId); } catch (err) {} }
                    });
                    btn.addEventListener('pointerup', stop);
                    btn.addEventListener('pointercancel', stop);
                    btn.addEventListener('pointerleave', stop);
                    btn.addEventListener('click', function (e) {
                        // click de PONTEIRO (mouse/toque) já foi tratado no pointerdown → ignora p/ não duplicar.
                        // click de TECLADO (Enter/Espaço) tem detail === 0 → executa 1 passo (acessibilidade).
                        if (e.detail === 0) step();
                    });
                } else {
                    // fallback (navegadores sem Pointer Events): clique simples (mouse e teclado)
                    btn.addEventListener('click', step);
                }

                // teclado (acessibilidade): Enter/Espaço dão 1 passo via clique nativo do <button>;
                // garantimos parada de qualquer auto-repeat ao soltar o foco/tecla
                btn.addEventListener('keyup', stop);
                btn.addEventListener('blur', stop);
            }
            bindStep(dec, -1);
            bindStep(inc, +1);

            step.querySelectorAll('[data-dx-quick]').forEach(function (chip) {
                chip.addEventListener('click', function () {
                    setValue(parseFloat(chip.getAttribute('data-dx-quick')));
                    step.querySelectorAll('[data-dx-quick]').forEach(function (c) { c.classList.remove('is-active'); });
                    chip.classList.add('is-active');
                });
            });
        });

        // ════════════════════════════════════════════════════════════════
        //  LEAD-GATE — validação CLIENT-SIDE (sem envio ao backend)
        // ════════════════════════════════════════════════════════════════
        var leadForm = quiz.querySelector('[data-dx-lead-form]');

        function fieldValid(input) {
            var v = (input.value || '').trim();
            if (!v) return false;
            var type = input.getAttribute('data-dx-type');
            if (type === 'email') return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
            if (type === 'tel') return (v.replace(/\D/g, '').length >= 10); // DDD + número
            if (type === 'fullname') return v.split(/\s+/).length >= 2;      // nome + sobrenome
            return v.length >= 2;
        }

        function validateLead() {
            var fields = Array.prototype.slice.call(leadForm.querySelectorAll('[data-dx-lead]'));
            var firstInvalid = null;
            fields.forEach(function (input) {
                var ok = fieldValid(input);
                var field = input.closest('.dx-field');
                if (field) field.classList.toggle('has-error', !ok);
                // aria-invalid só existe enquanto há erro: deixar "false" pendurado faz o
                // leitor de tela anunciar "inválido" corrigido em campo nunca validado.
                if (ok) input.removeAttribute('aria-invalid');
                else input.setAttribute('aria-invalid', 'true');
                if (!ok && !firstInvalid) firstInvalid = input;
            });
            // as caixas de erro não são live region: seriam 4 anúncios se atropelando num submit vazio.
            // Quem avisa é o foco no primeiro campo inválido, que faz o leitor ler o aria-describedby.
            if (firstInvalid) { firstInvalid.focus(); return false; }
            return true;
        }

        if (leadForm) {
            // máscara de telefone (BR): (XX) XXXXX-XXXX ou (XX) XXXX-XXXX
            // (mesma lógica da página AgendDemo)
            var telEl = leadForm.querySelector('#dx-telefone');
            if (telEl) {
                telEl.setAttribute('inputmode', 'tel');
                telEl.setAttribute('maxlength', '15');
                telEl.addEventListener('input', function () {
                    var d = telEl.value.replace(/\D/g, '').slice(0, 11);
                    var out = d;
                    if (d.length > 2 && d.length <= 6) out = '(' + d.slice(0, 2) + ') ' + d.slice(2);
                    else if (d.length > 6 && d.length <= 10) out = '(' + d.slice(0, 2) + ') ' + d.slice(2, 6) + '-' + d.slice(6);
                    else if (d.length > 10) out = '(' + d.slice(0, 2) + ') ' + d.slice(2, 7) + '-' + d.slice(7);
                    telEl.value = out;
                });
            }

            // limpa erro do campo ao corrigir
            leadForm.querySelectorAll('[data-dx-lead]').forEach(function (input) {
                input.addEventListener('input', function () {
                    var field = input.closest('.dx-field');
                    if (field && field.classList.contains('has-error') && fieldValid(input)) {
                        field.classList.remove('has-error');
                        input.removeAttribute('aria-invalid');
                    }
                });
            });

            leadForm.addEventListener('submit', function (e) {
                e.preventDefault();
                if (!validateLead()) return;

                // Guarda nome/empresa para personalizar o relatório e marcar que o gate
                // foi preenchido (evita re-pedir ao refazer na sessão).
                var nome = (leadForm.querySelector('#dx-nome') || {}).value || '';
                var empresa = (leadForm.querySelector('#dx-empresa') || {}).value || '';
                try {
                    window.sessionStorage.setItem('dxLeadNome', nome.trim());
                    window.sessionStorage.setItem('dxLeadEmpresa', empresa.trim());
                } catch (err) {}

                // Envia o lead + respostas + resultado JÁ calculado ao backend (persiste +
                // e-mail ao comercial). NÃO bloqueia a tela de resultado: o cálculo é
                // client-side e a pessoa tem direito de ver o relatório mesmo se o POST
                // falhar (o erro é só logado). Por isso revelamos o resultado no finally.
                enviarLead();

                computeAndRender();
                show('result');
            });
        }

        // ── Monta o plano de ação em texto puro (p/ persistir + e-mail) ──
        function recommendationsPlainText() {
            return recommendations().map(function (r) {
                return '• ' + (r.txt || '').replace(/<[^>]+>/g, ''); // remove tags HTML do texto
            }).join('\n');
        }

        // ── Monta o payload (lead + respostas cruas + resultado calculado) ──
        function buildLeadPayload() {
            var r = compute();
            var m = maturity();
            var tier = tierFor(m);

            function num(id) { var e = leadForm.querySelector(id); return e ? (e.value || '').trim() : ''; }
            function round(v) { return (v === null || v === undefined || isNaN(v)) ? null : Math.round(v); }

            return {
                // lead
                Nome: num('#dx-nome'),
                Email: num('#dx-email'),
                Telefone: num('#dx-telefone'),
                Empresa: num('#dx-empresa'),
                // respostas cruas
                Porte: answers.porte,
                UsaAts: answers.usaAts === null ? null : (answers.usaAts === 1),
                Admissao: answers.admissao,
                HorasProcesso: answers.horasProcesso,
                ProcessosMes: answers.processosMes,
                Salario: answers.salario,
                Dor: answers.dor,
                // resultado calculado (fonte única = este JS)
                IndiceMaturidade: m,
                FaixaMaturidade: tier.nome,
                EconomiaMes: round(r.custoEconMes),
                EconomiaAno: round(r.custoEconAno),
                HorasEconomizadasMes: Math.round(r.horasEconMes * 10) / 10,
                CustoPorProcesso: round(r.custoProc),
                RiscoContratacaoErrada: round(r.custoContratacaoErrada),
                PlanoAcao: recommendationsPlainText()
            };
        }

        function enviarLead() {
            if (!enviarUrl || !window.fetch) return; // sem endpoint configurado → não quebra a UX
            var submitBtn = leadForm.querySelector('.dx-lead__submit');
            if (submitBtn) { submitBtn.disabled = true; }

            var payload;
            try { payload = buildLeadPayload(); }
            catch (err) { if (submitBtn) submitBtn.disabled = false; return; }

            fetch(enviarUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                body: JSON.stringify(payload)
            }).then(function (res) {
                return res.text().then(function (t) {
                    var d = {}; try { d = t ? JSON.parse(t) : {}; } catch (_) {}
                    return { ok: res.ok, data: d };
                });
            }).then(function (r) {
                if (!r.ok || (r.data && r.data.ok === false)) {
                    console.error('[Empregare][Diagnostico] falha ao registrar o lead', r.data);
                }
            }).catch(function (err) {
                console.error('[Empregare][Diagnostico] erro de rede ao registrar o lead', err);
            }).then(function () {
                if (submitBtn) submitBtn.disabled = false; // libera o botão (refazer/voltar)
            });
        }

        // ════════════════════════════════════════════════════════════════
        //  CÁLCULO DO DIAGNÓSTICO (fiel à fórmula oficial)
        // ════════════════════════════════════════════════════════════════
        function compute() {
            var horas = answers.horasProcesso || 0;    // horas por processo (hoje)
            var processos = answers.processosMes || 0;  // processos por mês
            var salario = answers.salario || 0;         // salário médio das vagas

            var horasEconProc = horas * REDUCAO;                 // ex.: 8 × 0,90 = 7,2
            var horasComEmpregare = horas - horasEconProc;       // tempo restante (~10%)
            var minutosEconProc = horasEconProc * 60;            // ex.: 432
            var custoProc = horasEconProc * CUSTO_HORA;          // economia por processo (ex.: 7,2 × 18,75 = 135)
            var custoAtualProc = horas * CUSTO_HORA;             // custo operacional atual por processo
            var custoEmpregareProc = horasComEmpregare * CUSTO_HORA;

            var horasEconMes = horasEconProc * processos;        // ex.: 7,2 × 3 = 21,6
            var custoEconMes = custoProc * processos;            // ex.: 135 × 3 = 405
            var custoAtualMes = custoAtualProc * processos;      // custo operacional atual/mês
            var custoEmpregareMes = custoEmpregareProc * processos;
            var custoEconAno = custoEconMes * 12;
            var horasEconAno = horasEconMes * 12;
            var diasEconAno = horasEconAno / 8;                  // jornada de 8h → "dias devolvidos"

            // risco: custo de UMA contratação errada (benchmark de mercado)
            var custoContratacaoErrada = salario * 12 * BAD_HIRE;

            return {
                horas: horas, processos: processos, salario: salario,
                horasEconProc: horasEconProc, horasComEmpregare: horasComEmpregare,
                minutosEconProc: minutosEconProc,
                custoProc: custoProc, custoAtualProc: custoAtualProc, custoEmpregareProc: custoEmpregareProc,
                horasEconMes: horasEconMes, custoEconMes: custoEconMes,
                custoAtualMes: custoAtualMes, custoEmpregareMes: custoEmpregareMes,
                custoEconAno: custoEconAno, horasEconAno: horasEconAno, diasEconAno: diasEconAno,
                custoContratacaoErrada: custoContratacaoErrada
            };
        }

        /* ── ÍNDICE DE MATURIDADE (0–100) — modelo próprio documentado ────
         * Inspirado em modelos de Talent Acquisition Maturity (níveis do
         * RH ad-hoc/manual até estratégico). MAIOR = mais maduro/eficiente.
         * Soma de 4 fatores (máx. 100):
         *   1) Usa ATS ............................... +30  (alavanca de R&S)
         *   2) Admissão digital ..................... +25 / parcial +12 / papel 0
         *   3) Eficiência de tempo por processo ..... até +25
         *        ~4h → teto · ≥40h → 0
         *   4) Integração das ferramentas ........... +20 (ATS + admissão digital)
         *        só uma das duas → +10
         * Faixas (rótulo):
         *   0–34  RH Iniciante · 35–59 RH em Evolução
         *   60–84 RH Estruturado · 85–100 RH Estratégico
         */
        function maturity() {
            var m = 0;
            if (answers.usaAts === 1) m += 30;
            if (answers.admissao === 'digital') m += 25;
            else if (answers.admissao === 'parcial') m += 12;

            var horas = answers.horasProcesso || 0;
            m += 25 * Math.max(0, Math.min(1, (40 - horas) / 36)); // 4h→25, 40h+→0

            if (answers.usaAts === 1 && answers.admissao === 'digital') m += 20;
            else if (answers.usaAts === 1 || answers.admissao === 'digital') m += 10;

            return Math.max(0, Math.min(100, Math.round(m)));
        }

        function tierFor(m) {
            if (m >= 85) return {
                nome: 'RH Estratégico',
                desc: 'Sua operação já é madura. A Empregare ajuda a ganhar a última milha de tempo, dados e experiência do candidato.'
            };
            if (m >= 60) return {
                nome: 'RH Estruturado',
                desc: 'Bom nível de maturidade — mas ainda há horas e custo presos em etapas que dá para automatizar de ponta a ponta.'
            };
            if (m >= 35) return {
                nome: 'RH em Evolução',
                desc: 'Você já avançou, porém boa parte do processo ainda é manual. É aqui que a economia aparece rápido.'
            };
            return {
                nome: 'RH Iniciante',
                desc: 'Seu processo é muito manual e reativo — exatamente o cenário em que a Empregare gera o maior retorno, já na primeira vaga.'
            };
        }

        // ── Recomendações personalizadas (por ferramentas + dor) ────────
        function recommendations() {
            var recs = [];
            if (answers.usaAts === 0) {
                recs.push({ ic: 'bi-robot', txt: 'Adotar um <b>ATS com triagem por IA</b> elimina a leitura manual de currículos e organiza vagas, candidatos e etapas num só lugar.' });
            }
            if (answers.admissao === 'papel') {
                recs.push({ ic: 'bi-file-earmark-check-fill', txt: 'Trocar a admissão no papel por uma <b>admissão 100% digital</b> (OCR, validação de CPF na Receita e checagem para o eSocial) acaba com a papelada e o retrabalho.' });
            } else if (answers.admissao === 'parcial') {
                recs.push({ ic: 'bi-file-earmark-check-fill', txt: 'Completar a <b>digitalização da admissão</b> (assinatura eletrônica + validação para o eSocial) fecha as brechas que ainda geram erro e retrabalho.' });
            }

            var dorMap = {
                triagem:     { ic: 'bi-funnel-fill',     txt: 'Para a <b>triagem de currículos</b>, a IA lê e ordena os candidatos por aderência à vaga — você analisa só os mais qualificados, sem leitura manual.' },
                tempo:       { ic: 'bi-hourglass-split', txt: 'Para reduzir o <b>tempo de contratação</b>, a automação das etapas e a triagem por IA encurtam o processo de semanas para poucos dias.' },
                qualidade:   { ic: 'bi-arrow-repeat',    txt: 'Para evitar <b>contratações erradas e turnover</b>, os testes comportamentais e o ranking de aderência por IA ajudam a escolher quem realmente combina com a vaga.' },
                comunicacao: { ic: 'bi-chat-dots-fill',  txt: 'Para os <b>candidatos que somem</b>, o WhatsApp oficial integrado avisa cada etapa automaticamente e reduz o no-show nas entrevistas.' },
                organizacao: { ic: 'bi-files',           txt: 'Para acabar com o processo <b>espalhado em planilhas e sistemas soltos</b>, o ATS centraliza tudo num funil único e visível para o time.' },
                documentos:  { ic: 'bi-file-earmark-medical-fill', txt: 'Para a <b>burocracia da admissão</b>, a coleta digital com OCR e a checagem para o eSocial eliminam papelada e erro antes da contratação.' }
            };
            if (answers.dor && dorMap[answers.dor]) recs.push(dorMap[answers.dor]);

            // sempre fecha com o argumento "tudo num só lugar"
            recs.push({ ic: 'bi-stars', txt: 'Reunir <b>recrutamento, seleção e admissão num só software</b> — com IA e WhatsApp — é o que multiplica o retorno e devolve tempo estratégico ao RH.' });

            // remove duplicatas e limita a 4
            var seen = {}, out = [];
            recs.forEach(function (r) { if (!seen[r.txt]) { seen[r.txt] = 1; out.push(r); } });
            return out.slice(0, 4);
        }

        // ── Formatação pt-BR ────────────────────────────────────────────
        function fmtMoney(v) {
            return 'R$ ' + Math.round(v).toLocaleString('pt-BR');
        }
        function fmtHours(v) {
            var n = Math.round(v * 10) / 10;
            return n.toLocaleString('pt-BR', { minimumFractionDigits: (n % 1 === 0 ? 0 : 1), maximumFractionDigits: 1 }) + 'h';
        }
        function fmtInt(v) {
            return Math.round(v).toLocaleString('pt-BR');
        }

        function setText(sel, txt) {
            var el = quiz.querySelector(sel);
            if (el) el.textContent = txt;
        }
        function setHTML(sel, html) {
            var el = quiz.querySelector(sel);
            if (el) el.innerHTML = html;
        }
        function setBar(sel, pct) {
            var el = quiz.querySelector(sel);
            if (!el) return;
            if (prefersReducedMotion) { el.style.width = pct + '%'; return; }
            el.style.width = '0%';
            void el.getBoundingClientRect();
            el.style.width = pct + '%';
        }

        // ── Render do relatório ─────────────────────────────────────────
        function computeAndRender() {
            var r = compute();
            var m = maturity();
            var tier = tierFor(m);

            var nome = '', empresa = '';
            try {
                nome = (window.sessionStorage.getItem('dxLeadNome') || '').split(' ')[0];
                empresa = window.sessionStorage.getItem('dxLeadEmpresa') || '';
            } catch (e) {}

            // cabeçalho do relatório
            setText('[data-dx-result-greet]', empresa ? ('Diagnóstico · ' + empresa) : 'Seu diagnóstico');
            if (r.custoEconAno > 0) {
                setHTML('[data-dx-result-headline]',
                    (nome ? (nome + ', ') : '') + 'o seu recrutamento deixa <span class="dx-pop">' +
                    fmtMoney(r.custoEconAno) + '</span> por ano na mesa.');
            } else {
                setHTML('[data-dx-result-headline]', 'O seu diagnóstico de recrutamento e admissão');
            }
            setHTML('[data-dx-result-sub]',
                'Hoje sua maturidade é <b>' + tier.nome + '</b> (' + m + '/100). Veja abaixo o que isso custa — e o que muda com a Empregare.');

            // ── números (cards) ──
            setText('[data-dx-out-custo-mes]', fmtMoney(r.custoEconMes));
            setText('[data-dx-out-custo-proc]', fmtMoney(r.custoProc) + ' por processo');
            setText('[data-dx-out-horas-mes]', fmtHours(r.horasEconMes));
            setText('[data-dx-out-horas-proc]', fmtHours(r.horasEconProc) + ' por processo');
            setText('[data-dx-out-custo-ano]', fmtMoney(r.custoEconAno));
            setText('[data-dx-out-dias]', fmtInt(r.diasEconAno) + (Math.round(r.diasEconAno) === 1 ? ' dia' : ' dias'));

            // ── Índice de Maturidade (gauge) ──
            setText('[data-dx-score-tier]', tier.nome);
            setText('[data-dx-score-tier-desc]', tier.desc);

            var ring = quiz.querySelector('[data-dx-score-ring]');
            var numEl = quiz.querySelector('[data-dx-score-num]');
            var CIRC = 540; // ~ 2π·86 (igual ao stroke-dasharray do SVG)
            var offset = CIRC - (m / 100) * CIRC;

            if (prefersReducedMotion) {
                if (numEl) numEl.textContent = String(m);
                if (ring) ring.style.strokeDashoffset = String(offset);
            } else {
                if (ring) {
                    ring.style.transition = 'stroke-dashoffset 1.2s cubic-bezier(.4,0,.2,1)';
                    void ring.getBoundingClientRect();
                    ring.style.strokeDashoffset = String(offset);
                }
                if (numEl) {
                    var startTs = null, dur = 1200;
                    (function tick(ts) {
                        if (!startTs) startTs = ts;
                        var p = Math.min((ts - startTs) / dur, 1);
                        var eased = 1 - Math.pow(1 - p, 3);
                        numEl.textContent = String(Math.round(m * eased));
                        if (p < 1) window.requestAnimationFrame(tick);
                    })(performance.now ? performance.now() : 0);
                }
            }

            // ── Comparativo Hoje × Com a Empregare ──
            var ratio = r.horas > 0 ? Math.max(6, (r.horasComEmpregare / r.horas) * 100) : 6; // mín. 6% só p/ visual
            // tempo por processo
            setText('[data-dx-cmp-tempo-now]', fmtHours(r.horas));
            setText('[data-dx-cmp-tempo-ev]', fmtHours(r.horasComEmpregare));
            // custo operacional por mês
            setText('[data-dx-cmp-custo-now]', fmtMoney(r.custoAtualMes));
            setText('[data-dx-cmp-custo-ev]', fmtMoney(r.custoEmpregareMes));
            // animação das barras
            setBar('[data-dx-cmp-tempo-now-bar]', 100);
            setBar('[data-dx-cmp-tempo-ev-bar]', ratio);
            setBar('[data-dx-cmp-custo-now-bar]', 100);
            setBar('[data-dx-cmp-custo-ev-bar]', ratio);

            // ── Risco: contratação errada ──
            if (r.custoContratacaoErrada > 0) {
                setText('[data-dx-risk-num]', fmtMoney(r.custoContratacaoErrada));
                var riskWrap = quiz.querySelector('[data-dx-risk]');
                if (riskWrap) riskWrap.hidden = false;
            } else {
                var rw = quiz.querySelector('[data-dx-risk]');
                if (rw) rw.hidden = true;
            }

            // ── Plano de ação ──
            var list = quiz.querySelector('[data-dx-reco-list]');
            if (list) {
                list.innerHTML = '';
                recommendations().forEach(function (rec) {
                    var li = document.createElement('li');
                    li.className = 'dx-reco__item';
                    li.innerHTML = '<span class="dx-reco__ic"><i class="bi ' + rec.ic + '"></i></span><span>' + rec.txt + '</span>';
                    list.appendChild(li);
                });
            }

            // CTA aponta para o destino correto (AgendDemo)
            var cta = quiz.querySelector('[data-dx-result-cta]');
            if (cta && resultActionUrl && resultActionUrl !== '#') cta.setAttribute('href', resultActionUrl);
        }

        // ── Refazer diagnóstico ─────────────────────────────────────────
        var restartBtn = quiz.querySelector('[data-dx-restart]');
        if (restartBtn) {
            restartBtn.addEventListener('click', function () {
                answers = { porte: null, usaAts: null, admissao: null, horasProcesso: null, processosMes: null, salario: null, dor: null };
                quiz.querySelectorAll('[data-dx-choice].is-selected').forEach(function (c) {
                    c.classList.remove('is-selected');
                    c.setAttribute('aria-checked', 'false');
                });
                quiz.querySelectorAll('[data-dx-step][data-dx-kind="number"]').forEach(function (step) {
                    var input = step.querySelector('[data-dx-input]');
                    var def = parseFloat(step.getAttribute('data-dx-default')) || 1;
                    if (input) input.value = def;
                    answers[step.getAttribute('data-dx-key')] = def;
                    step.querySelectorAll('[data-dx-quick].is-active').forEach(function (c) { c.classList.remove('is-active'); });
                });
                show('intro');
            });
        }

        // ── Inicialização ───────────────────────────────────────────────
        setProgress('intro');
    });
})();
